export class ChangePasswordFirstAccess {
    userId: number;
    Token: string;    
    Password: string;
  documentNumber: number;
}